import { render } from "./LoaderView.vue?vue&type=template&id=61cf5a87"
import script from "./LoaderView.vue?vue&type=script&lang=js"
export * from "./LoaderView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__